<template>
  <section class="app-modal__section payment-plan-pay-modal__section--plan-overview">
    <div class="payment-plan-pay-modal__plan-card">
      <div class="payment-plan-pay-modal__plan-card-grid payment-plan-pay-modal__plan-card-grid--compact">
        <div class="payment-plan-pay-modal__readonly-item">
          <span>{{ counterpartyLabel }}</span>
          <strong>{{ counterpartyName }}</strong>
        </div>

        <div class="payment-plan-pay-modal__readonly-item">
          <span>{{ resolvedVoucherTypeLabel }}</span>
          <strong>{{ voucherTypeLabel }}</strong>
        </div>

        <div class="payment-plan-pay-modal__readonly-item">
          <span>{{ resolvedScheduledDateLabel }}</span>
          <strong>{{ formatDateShortMonth(scheduledDate) }}</strong>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PayModalSectionExpenseFeeInfo',
  props: {
    text: {
      type: Object,
      required: true,
    },
    counterpartyLabel: {
      type: String,
      default: 'Proveedor',
    },
    counterpartyName: {
      type: String,
      default: '-',
    },
    voucherTypeLabel: {
      type: String,
      default: '-',
    },
    scheduledDate: {
      type: String,
      default: '',
    },
    formatDateShortMonth: {
      type: Function,
      required: true,
    },
  },
  computed: {
    resolvedTitle() {
      return String(this.text?.payModal?.expenseFeeCard?.title || 'Pago de gasto/comision').trim();
    },
    resolvedVoucherTypeLabel() {
      return String(this.text?.payModal?.expenseFeeCard?.fields?.voucherType || 'Tipo de comprobante').trim();
    },
    resolvedScheduledDateLabel() {
      return String(this.text?.payModal?.expenseFeeCard?.fields?.scheduledDate || 'Fecha programada').trim();
    },
  },
};
</script>